var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gat-tab',{attrs:{"items":_vm.tabs,"show-in-toolbar":true}}),_c('keep-alive',[(!_vm.loadingPortCall)?_c('router-view',{attrs:{"callId":_vm.callId,"location":"portcall","parentId":_vm.callId,"accessGroup":_vm.webAccessGroup}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }